import React, { Component } from 'react'
import { getUser } from '../../../actions/session';
import axios from 'axios';
import { Notifications } from '../../common/notification';
import { ACCOUNT_ACTIVITY_URL, LOGIN_URL } from '../../../config/rest_endpoints';
import CustomLoader from '../../common/loader';
import { withRouter } from 'react-router-dom';

// datetime picker imports
import DateRangePicker from 'react-bootstrap-daterangepicker';
import moment from "moment";

var firstDate = new Date();
const startT = moment(firstDate.getTime()).subtract(1, 'h')

export class AccountActivity extends Component {
    constructor(props) {
        super(props)
        // initializing states
        this.state = {
            User: getUser(),
            startDate: startT,
            endDate: moment(new Date()),
            userNumber: this.props.userNumber,
            accountID: this.props.userId,
            activityData: [],
            isGetting: false,
            error: '',
            isError: false,
            isBtnSpin:false,
        }

        this.handleDate = this.handleDate.bind(this)
        this.accountActivityListing = this.accountActivityListing.bind(this)
    }

    componentDidMount() {
        this.accountActivityListing()
        this.setState({isBtnSpin: false})
    }

    // handle date and time on selection of datetime picker
    handleDate(date, value) {
        if (value == "start") {
            this.setState({ startDate: date }, () => {
                console.log('start', this.state.startDate);
            })
        } else {
            this.setState({ endDate: date }, () => {
                console.log('end', this.state.endDate);
            })
        }
    }

    // on filter we are getting acount acitivity list
    accountActivityListing() {
        const { User, accountID, startDate, endDate } = this.state
        var payload = {
        "startDate": Math.floor(startDate.toDate().getTime() / 1000.0),
        "endDate": Math.floor(endDate.toDate().getTime() / 1000.0) 
        }
        console.log("payload", payload);
        this.setState({ isGetting: true, isBtnSpin: true })
        var headers = { "Authorization": "Bearer " + User.token };
        axios.post(`${ACCOUNT_ACTIVITY_URL}/${accountID}/billing/reports/balance?page=1&limit=50`, payload, { headers }).then(res => {
            if (res) {
                console.log('res', res)
                this.setState({
                    activityData: res.data.data,
                    isGetting: false,
                    isBtnSpin: false
                })
            }
        }).catch(err => {
            const alert = err.response
            console.log(`alert.data.message`, alert.data.message )
            if (alert.data.message === 'invalid or expired jwt') {
                localStorage.removeItem('user');
                this.props.history.push(LOGIN_URL)
                Notifications.notify(alert.data.message, "Token Expire", "error")
            }
            Notifications.notify(alert.data.message, "Failed", "error")
            this.setState({
                isGetting: false,
                isBtnSpin: false
            })
        })
    }

    renderActivityListing() {
        const { activityData, error, isError } = this.state
        var nullData = (
            <div className="ml-4 mt-2">
                <div className="dataTables_info" id="DataTables_Table_0_info" role="status" aria-live="polite">Showing 0 of 0 entries</div>
                <div className="dataTables_paginate paging_simple_numbers" id="DataTables_Table_0_paginate"></div>
            </div>
        )
        var errorData = (
            <div className="ml-4 mt-2">
                <div class="alert alert-warning alert-styled-left alert-dismissible">
                    <button type="button" class="close" data-dismiss="alert"><span>×</span></button>
                    <span class="font-weight-semibold">Warning!</span> Better <a href="#" class="alert-link">check yourself</a>, you're not looking too good.
                </div>
            </div>
        )
        if (activityData === null) {
            return nullData
        }
        else if (isError) {
            return errorData
        }
        else {
            return activityData.map((row, idx) => {
                return (
                    <tr key={idx}>
                        <td style={{textAlign:'center'}}>{row.setuptime}</td>
                        <td style={{textAlign:'center'}}>{row.method}</td>
                        <td style={{textAlign:'center'}}>{row.requestType}</td>
                        <td style={{textAlign:'center'}}>{row.amount}</td>
                    </tr>
                )
            })
        }

    }

    render() {
        const { isGetting, startDate, endDate, isBtnSpin } = this.state
        return (
            <div>
                <div style={{border:'none',borderRadius:'5px',boxShadow:'0 0 20px rgba(0,0,0,.08)'}} className="card card-body ">
                    {/* <div className="card-header header-elements-inline p-0 py-1 mb-2">
                        <h5 style={{fontWeight:'700',fontSize:'24px'}} className="card-title"></h5>
                        <div className="header-elements">
                        </div>
                    </div> */}
                    {/* previous code start */}
                    <div class="d-flex justify-content-between flex-wrap bg-light rounded border p-0 mb-2">
                        <div class=" py-2 px-3 mb-1">
                            <div class="">
                                <label style={{fontWeight:'400',fontSize:'16px'}} className="fs-14">Start Date</label>
                                <div class="input-group">
                                <DateRangePicker
                                    onCallback={(date) => this.handleDate(date, "start")}
                                    initialSettings={{
                                    singleDatePicker: true,
                                    timePicker: true,
                                    showDropdowns: true,
                                    startDate: moment(startDate),
                                    locale: {
                                        format: 'MMMM/DD/YYYY h:mm A',
                                    },
                                    }}
                                >
                                <input  type="text" className="form-control" style={{ minWidth: '300px' }} />
                                </DateRangePicker>
                                </div>
                            </div>
                        </div>
                        {/* start date */}
                        <div class="py-2 px-3 mb-1 ">
                            <div class="">
                                <label style={{fontWeight:'400',fontSize:'16px'}} className="fs-14">End Date</label>
                                <div class="input-group">
                                <DateRangePicker
                                    onCallback={(date) => this.handleDate(date, "end")}
                                    initialSettings={{
                                    singleDatePicker: true,
                                    timePicker: true,
                                    showDropdowns: true,
                                    startDate: moment(endDate),
                                    locale: {
                                        format: 'MMMM/DD/YYYY h:mm A',
                                    },
                                    }}
                                >
                                <input type="text" className="form-control" style={{ minWidth: '300px' }} />
                                </DateRangePicker>
                                </div>
                            </div>
                        </div>
                        {/* end date */}
                        <div class="py-2 px-3 mb-1">
                            <div className="" style={{ marginLeft: '4px', marginTop: '2.4em'}}>
                                <button type="submit" className="btn btn-success btn-sm main-button " onClick={this.accountActivityListing} >Filter Date <i class={`${isBtnSpin ? 'icon-spinner4 spinner' : 'icon-calendar22'} ml-2`}></i></button>
                            </div>
                        </div>
                        {/* filter date */}
                    </div>
                    {/* previous code end */}
                    <div id="DataTables_Table_0_wrapper" className="dataTables_wrapper no-footer">
                        <div className="datatable-header">
                            <div id="DataTables_Table_0_filter" className="dataTables_filter">
                                {/* <label><span>Filter:</span>
                                    <input type="search" className="" placeholder="Type to filter..." aria-controls="DataTables_Table_0" />
                                </label> */}
                            </div>
                        </div>
                        <div className="datatable-scroll" style={{overflowX: 'auto'}}>
                            <table style={{border:'1px solid #ddd',borderTop:'0px solid #ddd',borderCollapse:'collapse'}} className="table table-striped  no-footer" id="DataTables_Table_0" role="grid" aria-describedby="DataTables_Table_0_info">
                                <thead>
                                    <tr className="stickeyHeader">
                                        <th style={{color:'black',borderBottom:'2px solid #dee2e6',fontSize:'16px',textAlign:'center'}}>Date</th>
                                        <th style={{color:'black',borderBottom:'2px solid #dee2e6',fontSize:'16px',textAlign:'center'}}>Method</th>
                                        <th style={{color:'black',borderBottom:'2px solid #dee2e6',fontSize:'16px',textAlign:'center'}}>Balance Type</th>
                                        <th style={{color:'black',borderBottom:'2px solid #dee2e6',fontSize:'16px',textAlign:'center'}}>Amount</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {isGetting ? <CustomLoader /> : this.renderActivityListing()}
                                </tbody>
                            </table>
                        </div>
                        <div className="datatable-footer">
                            <div className="dataTables_paginate paging_simple_numbers" id="DataTables_Table_0_paginate"></div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default withRouter(AccountActivity)
